import formatRefiner from '@/infrastructure/utils/formatRefiner';
import _ from 'lodash';
import { DetailServiceSymbol } from '@/services/DetailService';
import { injectService } from '@/inversify.config';
export function useFormatRefiner() {
    const detailService = injectService(DetailServiceSymbol);
    return formatRefiner({
        q: _.get(detailService, 'filterInfo.q', null),
        efq: _.get(detailService, 'filterInfo.efq', null),
    });
}
